import {
  API_ROLES,
  API_PERMISSIONS,
  API_ROLE_LOGS,
  API_ROLE,
} from "../../../shared/routes/auth.routes";

import { Client } from "../../../core/api-client";

export class RoleService {
  getRoles(params: any, body: any) {
    return Client.get(API_ROLES, { params: { ...params, ...body } });
  }  

  createRole(body: any) {
    return Client.post(API_ROLE, body);
  }

  updateRole(id: string, body: any) {
    return Client.put(`${API_ROLE}/${id}`, body);
  }

  deleteRole(id: string) {
    return Client.delete(`${API_ROLE}/${id}`);
  }

  getPermissions() {
    return Client.get(API_PERMISSIONS);
  }

  getRoleLogs(id: string) {
    return Client.get(`${API_ROLE_LOGS}/${id}`);
  }

 getRoleCodes() {
  return Client.get(API_ROLES);
}
}